module.exports = __webpack_public_path__ + "img/studentNull.055bcd5c.png";